$(document).ready(function(){

    validateForm({
        formId: 'form-slider'
        //formValidClass: 'Form_valid',
        //formInvalidClass: 'Form_invalid',
        //inputErrorClass: 'Input_error'
    });

    $('.FormSlider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        dots: false,
        adaptiveHeight: true,
        prevArrow: '',
        nextArrow: '<button type="button" class="FormSlider-Arrow FormSlider-Next Btn">' +
        'Следующий вопрос <svg width="9" height="14">\n' +
        '    <use\n' +
        '        xlink:href="/img/sprite.svg#arrow-all-project"\n' +
        '        href="/img/sprite.svg#arrow-all-project"></use>\n' +
        '</svg>' +
        '</button>'
    });

});